// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"c7b82bba9a0f0192","5285":"bd5f1abc9132143b"}[chunkId] + ".css";
};